// extracted by mini-css-extract-plugin
export default {"content":"j1aMn","tooltip":"CJ3eK"};